module.exports = __webpack_public_path__ + "static/media/complete-service.d74871cb.svg";